import { CheckoutState } from './checkoutState';

export const steps = ['auth', 'shipping', 'payment'] as const;

export type Step = (typeof steps)[number];

export const getStepFromRoute = (route: string) => route.slice(1).split('/').shift() as Step;

export const getInitialRoute = (checkoutState: CheckoutState) => {
  const locationSearch = new URLSearchParams(window.location.search);
  const isAmazonPayReviewPage = !!locationSearch.get('isAmazonPayReviewPage');
  const isExpressReviewPage = !!checkoutState.isExpressCheckout;
  const isPaypalReviewPage = !!locationSearch.get('isReviewPage');
  const isReviewPage = isAmazonPayReviewPage || isExpressReviewPage || isPaypalReviewPage;

  const firstName = checkoutState.orderState?.addresses?.shipping?.firstName ?? checkoutState.customer?.data.firstName;
  const lastName = checkoutState.orderState?.addresses?.shipping?.lastName ?? checkoutState.customer?.data.lastName;
  const hasFirstLastName = !!firstName && !!lastName;
  const showShipping = (!checkoutState.orderState?.addresses?.shipping || !hasFirstLastName) && !isReviewPage;

  if (!checkoutState.customer) {
    return '/auth';
  } else if (showShipping) {
    return '/shipping';
  } else {
    return '/payment';
  }
};
